import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import { registerFifteenTranslations } from "./i18n";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type {
  FifteenDefinition,
  FifteenProgress,
  FifteenSolution,
  FifteenSubmission,
} from "./types";

registerFifteenTranslations(i18n);

/** No `localFeedback`: a legal tray is always solvable, so there is nothing sound to flag. */
export const fifteenPuzzleModule: PuzzleTypeModule<
  FifteenDefinition,
  FifteenSubmission,
  FifteenProgress,
  FifteenSolution
> = {
  key: "fifteen_puzzle",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
};
